module.exports = __webpack_public_path__ + "static/media/YM48_0.2389a69f.jpg";